.panContainer {
  width: 100%;
  display: flex;
  align-items: center;
}

.centerContainer {
  cursor: pointer;
  margin-right: 4px;
  height: 4px;
  width: 4px;
  background-color: var(--tuna-palette-secondary-light);
}

.leftContainer {
  background-color: var(--tuna-palette-action-hover);
  cursor: pointer;
  margin-right: 4px;
  height: 4px;
  flex: 1;
  transform: rotateY(180deg);
}

.rightContainer {
  cursor: pointer;
  margin-right: 4px;
  height: 4px;
  width: 4px;
  background-color: var(--tuna-palette-secondary-light);
  flex: 1;
}

.panBar {
  background-color: var(--tuna-palette-primary-light);
  height: 4px;
}
